import { createFileRoute } from "@tanstack/react-router";

import { ConnectDonePage } from "@/connect/ConnectDonePage";
import { validateConnectDoneSearch } from "@/connect/search";

export const Route = createFileRoute("/conectar/listo")({
  validateSearch: validateConnectDoneSearch,
  component: ConnectDonePage,
});
